/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

import Hour from './Hour';

const Wrapper = styled.div`
  background-color: ${props => props.theme.tvGuide.hours.background};
  max-width: 1000px;
  margin: auto;
  padding: 0 0 0 100px;

  &&& .slick-prev {
    left: -100px;
  }

  &&& .slick-next {
    right: 0;
  }
`;

const Slide = styled.div`
  overflow: hidden;
  height: 40px;
`;

// eslint-disable-next-line react/prefer-stateless-function
class Hours extends React.PureComponent {
  render() {
    const {
      className,
      sliderConfig,
      initialSlide,
      hours,
      onSlideChange,
      sliderRef,
      t
    } = this.props;

    return (
      <Wrapper className={className}>
        <Slider
          {...sliderConfig}
          initialSlide={initialSlide}
          beforeChange={onSlideChange}
          ref={sliderRef}
        >
          <Slide data-index={0}>
            {hours.map((hour, index) => (
              <Hour label={t(hour.label)} key={`Hour${index}`} />
            ))}
          </Slide>
        </Slider>
      </Wrapper>
    );
  }
}

Hours.displayName = 'Hours';

export default Hours;
